"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dotCase = exports.kebabCase = exports.constantCase = exports.snakeCase = exports.camelCase = exports.pascalCase = exports.noCase = void 0;

var format = function format(str) {
  return str.replace(/[^A-Za-z0-9]/g, ' ').replace(/ +/, ' ').trim();
};

exports.noCase = function (str) {
  return format(str.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2"));
};

var toPascalCaseWord = function toPascalCaseWord(word) {
  var firstChar = word.charAt(0).toUpperCase();
  var rest = word.substr(1).toLowerCase();
  return firstChar + rest;
};

exports.pascalCase = function (str) {
  return (0, exports.noCase)(str).replace(/ (?=\d)/g, '_').split(' ').map(toPascalCaseWord).join('');
};

exports.camelCase = function (str) {
  return (0, exports.pascalCase)(str).replace(/^[A-Z]/, function (s) {
    return s.toLowerCase();
  });
};

exports.snakeCase = function (str) {
  return (0, exports.noCase)(str).replace(/ /g, '_').toLowerCase();
};

exports.constantCase = function (str) {
  return (0, exports.noCase)(str).replace(/ /g, '_').toUpperCase();
};

exports.kebabCase = function (str) {
  return (0, exports.noCase)(str).replace(/ /g, '-').toLowerCase();
};

exports.dotCase = function (str) {
  return (0, exports.noCase)(str).replace(/ /g, '.').toLowerCase();
};